import NotificationsChild from './NotificationsChild'
import './NotificationsParent.css'
import { init_NotificationObject, NotificationObject } from '../../interfaces/APIInterface'
import { useEffect, useState } from 'react';
import NotificationFlyout from './NotificationFlyout';
import KeyboardArrowUpSharpIcon from '@mui/icons-material/KeyboardArrowUpSharp';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { IconButton } from '@mui/material';

const NOTIFICATION_PAGE_SIZE = 50;

const NotificationsParent = (props: any) => {
    const [viewNotification, setViewNotification] = useState<boolean>(false);
    const [notificationOffset, setNotificationOffset] = useState<number>(0);
    const [notificationToView, setNotificationToView] = useState<NotificationObject>(init_NotificationObject);
    const [notifications, setNotifications] = useState<Array<NotificationObject>>(props.notificationList);
    const [showUnreadOnly, setShowUnreadOnly] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    let navigate = useNavigate();

    const userRedirect = (navigateTo: {pathname: string, search: string}) => {
        setViewNotification(false);
        navigate(navigateTo);
    }

    const reloadNotifications = () => {
        setIsLoading(true);
        props.callNotificationsAPI()
            .then(() => setIsLoading(false));
    }

    useEffect(() => {
        if (showUnreadOnly === true) {
            let unacknowledged = props.notificationList.filter((item: NotificationObject) => !item.adminAcknowledged);
            setNotifications(unacknowledged);
            if (unacknowledged.length > 0) {
                let maxOffset = Math.floor((unacknowledged.length-1)/NOTIFICATION_PAGE_SIZE)*NOTIFICATION_PAGE_SIZE;
                if (notificationOffset > maxOffset) {
                    setNotificationOffset(maxOffset);
                }
            } else {
                setNotificationOffset(0);
            }
        } else {
            setNotifications(props.notificationList);
        }
    }, [props.notificationList, showUnreadOnly]);

    const handleClick = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    return (
        <>
            {isLoading ? <span className="working">Loading</span> : <div className='container'>
                <NotificationFlyout viewNotification={viewNotification} setViewNotification={setViewNotification} acknowledgeNotification={props.acknowledgeNotification} note={notificationToView} userRedirect={userRedirect} />
                <div className="notification-buttons row">
                    <FormControlLabel  control={<Switch checked={showUnreadOnly} onChange={() => setShowUnreadOnly(!showUnreadOnly)} />} label="Unacknowledged Only" />
                    <div className="notification-navbuttons row">
                        {notifications && (
                            <>
                                <Typography className="notification-paging">{(notifications?.length > 0) ? (notificationOffset+1) : 0}-{notifications?.length > (notificationOffset+NOTIFICATION_PAGE_SIZE) ? notificationOffset+NOTIFICATION_PAGE_SIZE : (notifications?.length ?? 0)} of {notifications?.length ?? 0}</Typography>
                                {(notifications.length > NOTIFICATION_PAGE_SIZE) && (
                                <>
                                    <div className="notification-navbutton-spacer"></div>
                                    <IconButton
                                        onClick={() => setNotificationOffset(((notificationOffset - NOTIFICATION_PAGE_SIZE) < 0) ? 0 : (notificationOffset - NOTIFICATION_PAGE_SIZE))}
                                        disabled={notificationOffset == 0}
                                    >
                                        <KeyboardArrowLeftIcon/>
                                    </IconButton>
                                    <div className="notification-navbutton-spacer"></div>
                                    <IconButton
                                        onClick={() => setNotificationOffset(((notificationOffset+NOTIFICATION_PAGE_SIZE) >= notifications.length) ? notificationOffset : (notificationOffset + NOTIFICATION_PAGE_SIZE))}
                                        disabled={(notificationOffset+NOTIFICATION_PAGE_SIZE) >= notifications.length}
                                    >
                                        <KeyboardArrowRightIcon/>
                                    </IconButton>
                                </>
                                )}
                            </>
                        )}
                    </div>
                    <Button onClick={reloadNotifications} className="button col-sm-2 col-sm-push-6"><i className="fa fa-refresh"></i> Refresh Notifications</Button>
                </div>
            <Stack spacing={2}>
                {notifications.slice(notificationOffset, notificationOffset+NOTIFICATION_PAGE_SIZE).map((note: NotificationObject) => (
                    <NotificationsChild
                        key={note.id}
                        notification={note}
                        acknowledgeNotification={props.acknowledgeNotification}
                        setViewNotification={setViewNotification}
                        setNotificationToView={setNotificationToView}
                        userRedirect={userRedirect}
                    />
                ))}
            </Stack>
            <Button className="jump-top" onClick={handleClick}><KeyboardArrowUpSharpIcon /></Button>
           
        </div> 
        }
        </>
    )
}

export default NotificationsParent
